module.exports = __webpack_public_path__ + "static/media/contact.b4b0b86d.jpg";